import './locales/register'
import './dashboard-widgets'
import './page-slots'
import { lazy } from 'react'
import ErrorPage from '@/components/ErrorBoundary/ErrorPage'

import { RouteObject } from 'react-router-dom'

const Analytics = lazy(() => import('./components/Analytics'))
const BusinessPerformance = lazy(
    () => import('./components/BusinessPerformance')
)
const BusinessTargets = lazy(() => import('./components/BusinessTargets'))
const Incomes = lazy(() => import('./components/EmployeeIncome'))
const Revenue = lazy(() => import('./components/Revenue'))
const SalePerformances = lazy(() => import('./components/SalePerformances'))
const ServiceMonthlyReport = lazy(
    () => import('./components/ServiceMonthlyReport')
)
const TargetAnalytics = lazy(() => import('./components/TargetAnalytics'))
const Vpbank = lazy(() => import('./components/Vpbank'))
const Receivables = lazy(() => import('./components/Receivables'))
const ReceivableCustomer = lazy(
    () => import('./components/Receivables/CustomerDetail')
)

const ReportModule: RouteObject = {
    path: 'reports',
    children: [
        {
            path: 'customers',
            element: <SalePerformances />,
        },
        {
            path: 'services',
            element: <ServiceMonthlyReport />,
        },
        {
            path: 'analytics',
            element: <Analytics />,
        },
        {
            path: 'incomes',
            element: <Incomes />,
        },
        {
            path: 'business-targets',
            element: <BusinessTargets />,
        },
        {
            path: 'targets-analytics',
            element: <TargetAnalytics />,
        },
        {
            path: 'revenues',
            element: <Revenue />,
        },
        {
            path: 'financials',
            element: <BusinessPerformance />,
        },
        {
            path: 'vpbank',
            element: <Vpbank />,
        },
        {
            path: 'receivables',
            element: <Receivables />,
        },
        {
            path: 'receivables/customers/:id',
            element: <ReceivableCustomer />,
        },
    ],
    errorElement: <ErrorPage status={500} />,
}

export default ReportModule
